import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { EnquiryModel } from "../common";

import "./index.css";
import { apiURL } from "../../utils/config";
import { fDate } from "../../utils/formatTime";
import { visitorGame } from "../../appRedux/actions/games";

function FeaturesSection({ isLimit }) {
  const dispatch = useDispatch();
  const { promoterCode } = useParams();
  const { gamesList, ipAddressInfo, defaultTheme } = useSelector((state) => ({
    gamesList: state.games.gamesList,
    ipAddressInfo: state.games.ipAddressInfo,
    defaultTheme: state.common.theme,
  }));
  //
  // var limit = isLimit ? isLimit : gamesList.length;
  // const currentTheme = localStorage.getItem("theme");
  const [theme, setTheme] = useState(defaultTheme);
  useEffect(() => {
    if (defaultTheme) {
      setTheme(defaultTheme);
    }
  }, [defaultTheme]);

  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  const onClickPlay = (gameId, url, gamePlatform) => {
    if (ipAddressInfo && ipAddressInfo.ip && gameId) {
      dispatch(
        visitorGame({
          promoterCode,
          gameId,
          gamePlatform,
          ipAddress: ipAddressInfo.ip,
          country: ipAddressInfo.country_name,
          city: ipAddressInfo.country,
          ipAddressInfo,
        })
      );
    }
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  return (
    <section className="amit-features pt-5" id="work">
      <div className="container  pt-2">
        {/* <h5 className="title-subw3hny text-center"> gamess</h5> */}
        <h3 className="title-ac mb-5 text-center">
          <span className="primary-color">Our</span> Games
        </h3>
        <div className="row ">
          {gamesList &&
            gamesList.map((row) => {
              const {
                _id,
                name,
                createdAt,
                createrInfo,
                sortDescription,
                description,
                googleStoreUrl,
                appleStoreUrl,
                thumbnail,
              } = row;

              console.log({ row });
              return (
                <div key={row._id} className="col-lg-4 col-md-6">
                  <div className="upcoming-game-item mb-40 ">
                    <div className="upcoming-game-head">
                      <div className="uc-game-head-title">
                        <span className="text-uppercase">{fDate(createdAt)}</span>
                        <h4>
                          <Link to="">{name}</Link>
                        </h4>
                      </div>
                      <div className="uc-game-price">
                        {appleStoreUrl !== "" && (
                          <i
                            className="fa fa-apple-store-icon"
                            onClick={() => onClickPlay(_id, appleStoreUrl, "IOS")}
                          />
                        )}
                        {googleStoreUrl !== "" && (
                          <i
                            className="fa fa-google-play-icon"
                            onClick={() => onClickPlay(_id, googleStoreUrl, "Android")}
                          />
                        )}
                        {/* <i className="fa fa-apple-store-icon" /> */}
                      </div>
                    </div>
                    <p>{sortDescription.slice(0, 120)}</p>
                    <div className="upcoming-game-thumb">
                      <img
                        src={thumbnail && thumbnail.url ? apiURL + thumbnail.url : ""}
                        alt={name}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </section>
  );
}

export default FeaturesSection;
